import {
  useLocation,
  withRouter,
} from "react-router-dom/cjs/react-router-dom.min";
import "react-toastify/dist/ReactToastify.css";
import MemberTypeRequestMultazim from "./MemberTypeRequestMultazim";
import MemberTypeRequestTawajahTalab from "./MemberTypeRequestTawajahTalab";
import MemberTypeRequestMuatazir from "./MemberTypeRequestMuatazir";

const MemberTypeRequest = () => {
  const location = useLocation();
  const memberTypeData = location.state?.memberTypeData;

  return (
    <div className="wrapper-custom wrapper wrapper-content animated fadeInRight">
      {memberTypeData.memberType.label === "ملتزم" ? (
        <MemberTypeRequestMultazim memberTypeData={memberTypeData} />
      ) : memberTypeData.memberType.label1 === "توجہ طلب" ? (
        <MemberTypeRequestTawajahTalab memberTypeData={memberTypeData} />
      ) : memberTypeData.memberType.label1 === "معتذر" ? (
        <MemberTypeRequestMuatazir memberTypeData={memberTypeData} />
      ) : null}
    </div>
  );
};

export default withRouter(MemberTypeRequest);
